/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Stats_Total_ChatsInputs */



/**
* | output |
* | --- |
* | "Total Chats" |
*
* @param {Projects_Stats_Total_ChatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_stats_total_chats = /** @type {((inputs?: Projects_Stats_Total_ChatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Stats_Total_ChatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamt-Chats")
	return /** @type {LocalizedString} */ ("Total Chats")
});